module.exports = __webpack_public_path__ + "img/banner_success_plain.36a56df8.webp";